import { useMemo, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

function Testimonial() {
  const [search, setSearch] = useState("");
  const [openFaq, setOpenFaq] = useState(null);

  const testimonials = [
    {
      name: "Tony Rush",
      rating: "★★★★★",
      review: "Throttle cable feels extremely smooth and precise.",
      details: "Verified Buyer • Delhi • Pulsar 150",
      image: "https://i.pravatar.cc/100?img=12",
    },
    {
      name: "Mia Alicia",
      rating: "★★★★☆",
      review: "Clutch cable quality is excellent in city traffic.",
      details: "Verified Buyer • Mumbai • Royal Enfield",
      image: "https://i.pravatar.cc/100?img=32",
    },
    {
      name: "Rahul Sharma",
      rating: "★★★★★",
      review: "Brake cable performance is strong even at high speed.",
      details: "Verified Buyer • Jaipur • Yamaha FZ",
      image: "https://i.pravatar.cc/100?img=45",
    },
    {
      name: "Aman Verma",
      rating: "★★★★★",
      review: "Installation was easy and quality feels premium.",
      details: "Verified Buyer • Gurgaon • RE Classic 350",
      image: "https://i.pravatar.cc/100?img=56",
    },
  ];

  const products = [
    {
      name: "Throttle Cable",
      img: "https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=600",
      desc: "Smooth acceleration and precise control.",
    },
    {
      name: "Clutch Cable",
      img: "https://images.unsplash.com/photo-1558981285-6f0c94958bb6?w=600",
      desc: "Effortless gear shifting experience.",
    },
    {
      name: "Brake Cable",
      img: "https://images.unsplash.com/photo-1558980394-4c7c9299fe96?w=600",
      desc: "Reliable braking in all conditions.",
    },
  ];

  const filtered = useMemo(() => {
    return testimonials.filter((t) =>
      `${t.name} ${t.review} ${t.details}`
        .toLowerCase()
        .includes(search.toLowerCase()),
    );
  }, [search, testimonials]);

  const faqs = [
    {
      q: "How long do your cables last?",
      a: "Our cables typically last 2–5 years depending on usage and maintenance.",
    },
    {
      q: "Are these cables compatible with all bikes?",
      a: "Yes, they are compatible with most major motorcycle brands in India.",
    },
    {
      q: "Do you provide warranty?",
      a: "Yes, all products come with manufacturing warranty and support.",
    },
    {
      q: "Can I install them myself?",
      a: "Yes, but professional installation is recommended for best safety.",
    },
    {
      q: "Do you offer bulk pricing?",
      a: "Yes, special pricing is available for dealers and workshops.",
    },
    {
      q: "How fast is delivery?",
      a: "Delivery takes 2–5 business days across most Indian cities.",
    },
  ];

  return (
    <div className="bg-black text-white min-h-screen">
      <Header />
      {/* HERO */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-lime-400 uppercase tracking-[6px] text-xs">
            Premium Motorcycle Cables
          </p>

          <h1 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
            Precision-engineered cables for{" "}
            <span className="text-lime-400">smooth throttle</span>,{" "}
            <span className="text-lime-400">accurate clutch</span>, and{" "}
            <span className="text-lime-400">safe braking</span>.
          </h1>

          <p className="text-gray-400 mt-6 max-w-xl">
            Trusted by thousands of riders across India for durability and
            performance.
          </p>

          <button
            onClick={() =>
              document.getElementById("reviews")?.scrollIntoView({
                behavior: "smooth",
              })
            }
            className="mt-8 px-6 py-3 bg-lime-400 text-black font-semibold rounded-lg"
          >
            Read Reviews
          </button>
        </div>

        <img
          src="https://superstrengthcables.in/wp-content/uploads/2020/11/custom-bike-builder-customer-testimonial.png"
          alt="testimonial"
          className="max-w-md w-full mx-auto"
        />
      </section>

      {/* STATS */}
      <section className="py-16 bg-zinc-950 text-center">
        <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {[
            ["10,000+", "Happy Riders"],
            ["50+", "Bike Models"],
            ["5 Years+", "Durability"],
            ["99%", "Satisfaction"],
          ].map(([num, label], i) => (
            <div key={i}>
              <h3 className="text-3xl font-bold text-lime-400">{num}</h3>
              <p className="text-gray-400 mt-2">{label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="py-20 text-center">
        <h2 className="text-4xl font-bold">Featured Products</h2>

        <div className="grid md:grid-cols-3 gap-8 mt-12 max-w-6xl mx-auto px-6">
          {products.map((p, i) => (
            <div key={i} className="bg-zinc-900 rounded-2xl overflow-hidden">
              <img
                src={p.img}
                alt={p.name}
                className="h-56 w-full object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold">{p.name}</h3>
                <p className="text-gray-400 mt-2">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ (OPEN STYLE) */}
      <section className="py-20 bg-zinc-950">
        <h2 className="text-center text-4xl font-bold">
          Frequently Asked Questions
        </h2>

        <div className="max-w-4xl mx-auto px-6 mt-10 space-y-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
                className="w-full flex justify-between items-center px-6 py-5 text-left"
              >
                <span className="font-semibold">{item.q}</span>
                <span className="text-lime-400 text-xl">
                  {openFaq === i ? "−" : "+"}
                </span>
              </button>

              {openFaq === i && (
                <div className="px-6 pb-5 text-gray-400">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* SEARCH */}
      <section className="py-12">
        <div className="max-w-3xl mx-auto px-6">
          <input
            type="text"
            placeholder="Search reviews..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-5 py-4 bg-zinc-900 border border-zinc-800 rounded-xl"
          />
        </div>
      </section>

      {/* REVIEWS */}
      <section id="reviews" className="pb-24">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          {filtered.length === 0 ? (
            <p className="text-center text-gray-400 col-span-2">
              No reviews found.
            </p>
          ) : (
            filtered.map((t, i) => (
              <div
                key={i}
                className="bg-zinc-900 border border-zinc-800 p-6 rounded-2xl"
              >
                <div className="flex items-center gap-4">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-12 h-12 rounded-full"
                  />
                  <div>
                    <h3 className="font-semibold">{t.name}</h3>
                    <p className="text-lime-400">{t.rating}</p>
                  </div>
                </div>

                <p className="text-gray-400 mt-4">{t.review}</p>
                <p className="text-gray-500 text-sm mt-3">{t.details}</p>
              </div>
            ))
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 text-center">
        <h2 className="text-5xl font-bold">Ready to Upgrade Your Ride?</h2>
        <p className="text-gray-400 mt-6">
          Join thousands of satisfied riders today.
        </p>

        <button className="mt-8 px-8 py-4 bg-lime-400 text-black font-semibold rounded-lg">
          Shop Now
        </button>
      </section>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}

export default Testimonial;
